import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation } from 'react-query';

function useUploadImage({ headers = {} }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function upload(data) {
    return privateFetch.post(`/v1/admin/upload`, data, { headers }).then((res) => res.data);
  }

  return useMutation(upload, {
    onSuccess() {},
    onError() {},
    onSettled() {},
  });
}

export default useUploadImage;
